import { GitPullRequestIcon } from "lucide-react";
import { Chip } from "@/components/badge/chip";
import { Section } from "@/components/section";
import { PR_STATE } from "@/constants/pr-state";
import type { Prd } from "@/types/domain";

// PRs linked to this PRD — synced by the GitHub webhook, or written back by
// coding agents (wed skill `pr add` / `pr state`) / by hand via the API.
// Read-only here; each row opens the PR on GitHub. Hidden until the first PR is linked.
export const PrdPullRequestsSection = ({ prd }: { prd: Prd }) => {
  const prs = prd.pullRequests ?? [];
  if (prs.length === 0) return null;
  return (
    <Section title="关联 PR" className="mb-6">
      <ul className="divide-y rounded-md border">
        {prs.map((pr) => {
          const state = PR_STATE[pr.state] ?? PR_STATE.open;
          return (
            <li key={pr.url}>
              <a
                href={pr.url}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-muted/50"
              >
                <GitPullRequestIcon className="h-4 w-4 shrink-0 text-muted-foreground" />
                <span className="shrink-0 font-mono text-xs text-muted-foreground">
                  {pr.repo}#{pr.number}
                </span>
                <span className="min-w-0 flex-1 truncate">
                  {pr.title || pr.branch || pr.url}
                </span>
                {pr.agent && <Chip>{pr.agent}</Chip>}
                <Chip tone={state.tone}>{state.label}</Chip>
              </a>
            </li>
          );
        })}
      </ul>
    </Section>
  );
};
